<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10LZ6ro/tc-custom/9781555846367.jpg?1726871242817" alt="This image is the cover for the book Woodcuts of Women"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Woodcuts of Women
      </h1>
      <p class="bookDescription body article font2">
        <b>These ten stories of “intensity and bravado” by the acclaimed Chicano author explore love, lust, and longing among people struggling to find their way (Jean Thompson, <i>The New York Times Book Review</i>). </b><br/>  <br/> Featuring characters of Mexican American heritage, each of these haunting stories is crafted with Gilb’s quintessentially spare yet evocative language and explores the lives of men and women at odds with each other. Steeped in an ethos of regimented gender roles, the men in these stories see the women in their lives as little more than woodcuts<b>—</b>crude variations of their actual complexity; symbols of seduction, mystery, and power that will ultimately bring about their undoing.<br/>  <br/> At turns powerful and resonant, hopeful and humorous, <i>Woodcuts of Women</i> is a tour de force by one of America’s foremost Latino writers.<br/>  <br/> “Lonely, tough stories—stories that force us to confront what’s difficult in us, and in the people we love.” —<i>Esquire</i><br/>  <br/> “The gritty passions of men for women—the grand delusions and tender mercies—are the jukebox songs playing through the 10 stories of Gilb’s ‘Woodcuts of Women.’” —<i>San Francisco Chronicle</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dagoberto Gilb
      </h2>
      
      <p class="authorDescription body article">Dagoberto Gilb is an acknowledged master of the short story, the winner of the PEN/Hemingway Award, and a PEN/Faulkner finalist for his debut collection, The Magic of Blood, and was awarded a Guggenheim Fellowship for his fiction writing. His critically acclaimed collection Woodcuts of Women is now available in paperback and features ten moving and heartbreaking stories of lust, love, and longing among men and women struggling to find their way in the world. Written in Gilb's spare, humid language, each of these haunting stories is crafted with a poetic, aching beauty. At turns powerful and resonant, hopeful and humorous, Woodcuts of Women is a tour de force by one of America's foremost Latino writers. "The sheer intensity and bravado of [Gilb's] vision make this collection succeed." -- Jean Thompson, The New York Times Book Review "Lonely, tough stories -- stories that force us to confront what's difficult in us, and in the people we love." -- Adrienne Miller, Esquire "Gilb's stories read like verbal woodcuts deliberately unrefined and carefully unadorned, clear in their intent but without undue elaboration...." -- Sean Glennon, The Hartford Courant "...Gilb writes of the gritty passions of man for women, grand delusions and tender mercies...." -- Oscar C. Villalon, San Francisco Chronicle</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c16f59ea